export default __webpack_public_path__ + "static/media/invoiceTable.6945a51f.png";